import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Desktopview from './Desktopview';
import Mobileview from './MObileview';
import Page6 from './DesktopPages/Page6';
import MobilePage6 from './MobilePages/Page6';
import PrivacyPolicy from "./components/PrivacyPolicy";

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route 
          path="/" 
          element={isMobile ? <Mobileview /> : <Desktopview />} 
        />
        <Route 
          path="/Page6" 
          element={isMobile ? <MobilePage6 /> : <Page6 />} 
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App; 